<div fxLayout="column" class="page-layout simple" fxFlex>

  @if (!page?.get('hideLabel') && displayTitle && !isCustomBanner) {
    <div class="header p-16">
      @if(displayBtnBackToHome) {
        <button data-e2e="basic-page-back-to-home" routerLink="/home">
          <mat-icon svgIcon="arrow_back"></mat-icon>
          <span>{{'generic.back' | translate}}</span>
        </button>
      }
      <h2>{{ page?.get('label') }}</h2>
    </div>
  }

  <div class="content">

    <div [innerHTML]="page?.get('body')" [ngClass]="{'custom-page': isCustomBanner}" (click)="clickOnPage($event)"></div>

    @for (component of page?.get('components'); track component) {
      <app-dynamic
        [room]="component.module"
        [subject]="component.component"
        [params]="composeParams(component)"
      ></app-dynamic>
    }

    @if (iframeUrl) {
      <iframe [title]="accessibilityTitle | translate" allow="fullscreen" [src]="iframeUrl" style="width:100%; height: 100%;"></iframe>
    }

    @if (page?.get('pages').length) {
      <mat-accordion class="p-24" multi>
        @for (subPage of page.get('pages'); track subPage) {
          <div>
            @if (subPage.chapter) {
              <h3>{{ subPage.label }}</h3>
            }
            @if (subPage.chapter && subPage.body) {
              <h4 [innerHTML]="subPage.body"></h4>
            }
            @if (!subPage.chapter) {
              <mat-expansion-panel class="mb-24">
                <mat-expansion-panel-header>
                  <mat-panel-title fxLayoutAlign="center">
                    {{subPage.label}}
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <div [innerHTML]="subPage.body">
                </div>
              </mat-expansion-panel>
            }
          </div>
        }
      </mat-accordion>
    }
  </div>
</div>
